export const LOCALIZED_STRINGS = 
{
    "lf_fileset_doc_name": "Document Name",
    "lf_fileset_modified_date": "Modified Date",
    "lf_fileset_creation_date": "Creation Date",
    "lf_fileset_created_by": "Created by",
    "lf_fileset_entry_id": "Entry ID",
    "lf_fileset_extension": "Extension",
    "lf_fileset_modified_by": "Last modified by",
    "lf_fileset_status": "Status",
    "lf_fileset_checked_out_by": "Checked out by",
    "lf_fileset_electronic_file_last_modified": "Electronic file last modified",
    "lf_fileset_has_tags": "Has tags",
    "lf_fileset_indexed": "Indexed",
    "lf_fileset_latest_version": "Latest version",
    "lf_fileset_location_description": "Location description",
    "lf_fileset_pages": "Pages",
    "lf_fileset_template": "Template",
    "lf_fileset_text_pages": "Text pages",
    "lf_fileset_total_document_size": "Total document size",
    "lf_fileset_none_type": "(None)",
    "lf_fileset_deleted_message": "This file set has been deleted.",
    "lf_fileset_not_found_message": "This file set could not be found.",
    "lf_fileset_no_fileset_message": "No fileset has been selected.",
    "lf_fileset_reject_public_user_message": "File sets are not supported on public forms.",
    "lf_fileset_invalid_repository_error": "Unable to update to the new file set. The repository does not match the repository of the current instance.",
    "lf_fileset_type_requirements": " ({0} - {1} files)",
    "lf_fileset_type_requirements_same_min_max": " ({0} file(s))",
    "lf_fileset_num_documents": " Documents",
    "lf_fileset_select_import": "Select Import",
    "lf_fileset_import_from": "Import from:",
    "lf_fileset_local": "My Computer",
    "lf_fileset_repository": "Repository",
    "lf_fileset_import": "Import",
    "lf_fileset_refresh": "Refresh",
    "lf_fileset_remove": "Remove",
    "lf_fileset_change": "Change",
    "lf_fileset_confirm": "Confirm",
    "lf_fileset_cancel": "Cancel",
    "lf_fileset_ok": "OK",
    "lf_fileset_yes": "Yes",
    "lf_fileset_no": "No",
    "lf_fileset_false": "False",
    "lf_fileset_search_files": "Search files",
    "lf_fileset_select_file": "Select a File",
    "lf_fileset_download_file": "Download file",
    "lf_fileset_change_doc_type_pl": "Move to type",
    "lf_fileset_change_doc_type": "Move to type",
    "lf_fileset_file_type_min_error": "File type \"{0}\" requires at least {1} document(s).",
    "lf_fileset_file_type_max_error": "File type \"{0}\" only accepts {1} document(s).",
    "lf_fileset_required_status_error": "Required status \"{0}\" is not set for document {1}.",
    "lf_fileset_file_type_general_error": "Requirements are not met for one or more file types.",
    "lf_fileset_required_status_general_error": "Required status \"{0}\" is not set for one or more files.",
    "lf_fileset_init_general_error": "This file set is not configured.",
    "lf_fileset_doc_limit_error": "Unable to add more than {0} files to the file set.",
    "lf_fileset_forbidden_access_error_message": "Forbidden Access. Please verify user repository rights." ,
    "lf_fileset_failed_to_query_entries_error_message": "Failed to query from repository.",
    "lf_fileset_failed_to_download_selected_file": "Failed to download selected file. Please verify if the file exist.",
    "lf_fileset_no_content_to_export": "No data was available for download.", 
    "lf_fileset_success_update_source_folder": "Successfully updated the default source folder to \"{0}\"",
    "lf_fileset_success_update_dest_folder": "Successfully updated the destination folder to \"{0}\"",
    "lf_fileset_fail_update_source_folder": "Failed to update the source folder to \"{0}\". Process is misconfigured, please contact an administrator to fix the issue.",
    "lf_fileset_fail_update_dest_folder": "Failed to update the destination folder to \"{0}\". Process is misconfigured, please contact an administrator to fix the issue.",
    "lf_fileset_fail_local_upload_metadata": "Failed to query meta data for file entry ID: \"{0}\".",
    "lf_fileset_fail_to_select_repo_entry": "Failed to select file(s) from the folder browser, error: {0}"
}